import React from 'react';
import { InputNumber, Form, Checkbox, Collapse } from 'antd';
import { createUseStyles } from 'react-jss'

import KomissiiVYacheikakhBlock from '../../components/KomissiiVYacheikakhBlock'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

const { Panel } = Collapse;

const useStyles = createUseStyles({
    tabs: {
        '& .ant-tabs-nav': {
            margin: "0 0 6px 0"
        },
        '& .ant-tabs-tab + .ant-tabs-tab': {
            margin: "0 0 0 20px"
        },
        '& .ant-tabs-nav .ant-tabs-tab': {
            padding: "5px 0",
            fontSize: "13px"
        }
    },
    collapse: {
        '& .ant-collapse-content > .ant-collapse-content-box': {
            padding: "0px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow': {
            top: "-2px",
            left: "9px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header': {
            padding: "4px 10px",
            paddingLeft: "25px",
            fontWeight: "300"
        },
        '&.ant-collapse .filtered .filtered-header-wrapper .ant-card-body': {
            padding: "7px",
        }
    },
    fieldName: {
        fontWeight: "300"
    },
    fieldValue: {
        fontStyle: "italic",
        color: "black",
        fontWeight: "300"
    }
})

export default function IzmenitKomissiiPartneram(props) {
    const classes = useStyles()
    const { auth, object, form, create, sourceKey, queryFilterContext, soruceID } = props;
    const display = (object) => {
        let res = object.nomerAkkaunta + " ";

        if (object.akkauntiFedAkkaunt && object.akkauntiFedAkkaunt.length > 0) {
            res += "Счет федерации социальных танцев";
        } else if (object.akkauntiPolzovateleiAkkaunt && object.akkauntiPolzovateleiAkkaunt.length > 0) {
            res += object.akkauntiPolzovateleiAkkaunt.map(e => {
                return e.polzovatel.lastname + " " + e.polzovatel.firstname;
            }).join(" ");
        } else if (object.akkauntiRegionalnikhOtdeleniiAkkaunt && object.akkauntiRegionalnikhOtdeleniiAkkaunt.length > 0) {
            res += object.akkauntiRegionalnikhOtdeleniiAkkaunt.map(e => {
                return e.regionalnoOtdelenie.nazvanie;
            }).join(" ");
        } else if (object.akkauntiOrganizatorovAkkaunt && object.akkauntiOrganizatorovAkkaunt.length > 0) {
            res += "Организатор: " + object.akkauntiOrganizatorovAkkaunt.map(e => {
                return e.organizator.nazvanie;
            }).join(" ");
        } else if (object.akkauntiShkolAkkaunt && object.akkauntiShkolAkkaunt.length > 0) {
            res += "Школа: " + object.akkauntiShkolAkkaunt.map(e => {
                return e.shkola.nazvanieShkoliTantsev;
            }).join(" ");
        }
        return res;
    }
    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{ ...object }}
            >
                <div style={{ paddingBottom: "10px" }}>
                    {object?.sutKomissii &&
                        <div style={{ display: "flex", gap: "5px" }}>
                            {/* {JSX(()=>{console.log(object)})} */}
                            <div>
                                <span style={{ fontWeight: "300" }}>Комиссия: </span>
                            </div>
                            <div>
                                <div>
                                    <span>{object?.sutKomissii}</span>
                                </div>
                                {object?.meropriyatie && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>{object?.meropriyatie?.nazvanieMeropriyatiya}</span> - {dayjs(object?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} {(object?.meropriyatie?.mestoProvedeniya)? "("+object?.meropriyatie?.mestoProvedeniya?.name+")":""}
                                </div>}
                                {object?.organizatorFederatsiyaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>Федерация</span>
                                </div>}
                                {object?.organizatorRegionalnoeOtdelenieID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>{object?.organizatorRegionalnoeOtdelenie?.nazvanie}</span>
                                </div>}
                                {object?.organizatorShkolaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>{object?.organizatorShkola?.nazvanieShkoliTantsev}</span>
                                </div>}
                                {object?.organizatorMeropriyatiyaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>{object?.organizatorMeropriyatiya?.nazvanie}</span>
                                </div>}
                            </div>
                        </div>
                    }
                    {(object && object.akkaunt) &&
                        <div>
                            <span className={classes.fieldName}>Счет: </span><span className={classes.fieldValue}>{display(object.akkaunt)}</span>
                        </div>
                    }
                    {(object && object.kakVichislitAkkaunt) &&
                        <div>
                            <span className={classes.fieldName}>Определение счета: </span><span className={classes.fieldValue}>{object.kakVichislitAkkaunt.opisanie}</span>
                        </div>
                    }
                </div>
                <Form.Item label="Процент"
                    name="protsentKomissii"
                    rules={[{ required: false, message: 'Пожалуйста, укажите процент!' }]}
                >
                    <InputNumber style={{ width: "100%" }} step={1} />
                </Form.Item>
                <Form.Item label="Сумма"
                    name="summaKomissiii"
                    rules={[{ required: false, message: 'Пожалуйста, укажите сумму!' }]}
                >
                    <InputNumber style={{ width: "100%" }} step={1} />
                </Form.Item>
                <Form.Item
                    name="notActive"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Неактивная комиссия
                    </Checkbox>
                </Form.Item>
            </Form>
            <Collapse className={classes.collapse} >
                <Panel header="Услуги" key="service">
                    <KomissiiVYacheikakhBlock
                        auth={auth}
                        source={"/api/komissiivyacheikakh/bykom/" + object.ID}
                        sourceKey={sourceKey}
                        soruceID={soruceID}
                        object={object}
                        create={create}
                        context={{
                            mix: () => ({ ...queryFilterContext }),
                            object: () => ({ komissiyaPartneramID: object.ID }),
                        }}
                        title={<></>}
                        size="small"
                    />
                </Panel>
            </Collapse>
        </>
    );
}
